import { iframeResizer } from "iframe-resizer";

interface IframeProps {
  rootEl: HTMLElement;
}

const Iframe = (props: IframeProps) => {
  iframeResizer({ log: false, checkOrigin: false }, props.rootEl);
};

const init = () => {
  const iframes = document.querySelectorAll<HTMLElement>("[h-comp='iframe']");

  for (const iframe of iframes) {
    Iframe({ rootEl: iframe });
  }
};

init();
